<template>
    <div class="highlights">
        <h2 style="font-size: 48px; font-weight: 400;">Our Values</h2>
        <p style="font-size: 20px; font-weight: 400;">The principles that guide everything we do at Lagos Lawn Tennis
            Club</p>
    </div>
    <div class="card-container row">
        <div  class="col-md-4" v-for="(data, index) in ourValuesList" :key="index">
            <div class="first-card text-center">
                <div
                    style="border: 1px solid #DCE3E7; height: 74px; width: 74px; border-radius: 50%; padding: 10px; display: flex; justify-content: center; align-items: center; margin: 0 auto;">
                    <component :is="data.icon" style="color:#094923;" />
                </div>
                <h3>{{ data.title }}</h3>
                <p v-html="data.description"></p>
            </div>
        </div>
    </div>


</template>

<script setup>
/* eslint-disable */
import { Award, Heart, Shield, Star, Briefcase, Globe, Users } from "lucide-vue-next";
import { ref, onMounted } from "vue";
import axios from 'axios';


const ourValuesList = ref([]);
const icons = [Award, Heart, Shield, Star, Briefcase, Globe, Users];


onMounted( async () => {
  await listOurValuesRecords()
});


const listOurValuesRecords = async () => {
  try {
    const response = await axios.get('/ourvalues_lists.php', {});
    
    if (response.data.status) {
      // assign icons to each row
      ourValuesList.value = response.data.data.map((item, index) => ({
        ...item,
        icon: icons[index % icons.length] // rotate 7 icons
      }));
    } else {
      console.error(response.data.message);
    }

  } catch (error) {
    console.error(error.message);
  }
};


</script>

<style scoped lang="scss">
.highlights {
    max-width: 90%;
    margin: auto;
    margin-top: 5rem;
    display: flex;
    flex-direction: column;
    gap: 10px;
    justify-content: center;
    align-items: center;

}

.card-container {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 85%;
    margin-top: 20px;
    margin: 0 auto;


    .first-card {
        width: 320px;
        height: 300px;
        border: 1px solid #00000033;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 6px;
        margin: 10px;

        h2 {
            font-size: 28px;
            font-weight: 700;
            margin: 10px 0;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        h3 {
            font-size: 16px;
            font-weight: 600;
            margin: 10px 0;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 14px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            text-align: center;
            color: #555555;
        }
    }

    .second-card {
        width: 680px;
        height: 320px;
        border: 1px solid #00000033;
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 10px;

        h2 {
            font-size: 48px;
            font-weight: 700;
            margin: 10px 0;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        h3 {
            font-size: 20px;
            font-weight: 600;
            margin: 10px 0;
            font-family: "Open Runde", sans-serif;
            text-align: center;
        }

        p {
            font-size: 16px;
            font-weight: 400;
            font-family: "Open Runde", sans-serif;
            text-align: center;
            color: #555555;
        }
    }
}

@media (max-width: 768px) {
    .highlights {
        max-width: 100%;
    }

    .card-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 10px;
        width: 100%;
        margin: 0 auto;
        margin-top: 20px;

        .first-card {
            width: 100%;
            height: 320px;
            margin: 0px;
        }

        .second-card {
            width: 100%;
            height: 320px;
        }
    }
}
</style>
